import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from '../../styles/common/RefundModal.module.css';
import modalStyles from '../../styles/common/Modal.module.css';

interface RefundModalProps {
    show: boolean;
    onHide: () => void;
}

const RefundModal: React.FC<RefundModalProps> = ({
    show,
    onHide,
}) => {
    const brandName = process.env.REACT_APP_BRAND_NAME || "elPaket";

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            className={styles.refundModal}
            contentClassName={styles.scaleIn}
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title as="h3" className={modalStyles.modalTitle}>
                    Política de Reembolsos
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="refund-content">
                    <p>
                        Esta Política de Reembolsos regula las condiciones bajo las cuales EnviarLatam LLC, operador de la marca comercial {brandName} ("la Empresa"), podrá autorizar reembolsos o compensaciones relacionados con los servicios prestados.
                    </p>
                    <p>
                        El uso de nuestros servicios implica la aceptación de esta política y de los Términos y Condiciones vigentes.
                    </p>

                    <h5>1. Elegibilidad</h5>
                    <p>
                        Las solicitudes de reembolso o compensación serán evaluadas individualmente y podrán proceder únicamente cuando la Empresa determine que existe una responsabilidad atribuible a la prestación del servicio.
                    </p>
                    <p>
                        La presentación de una solicitud no garantiza su aprobación.
                    </p>

                    <h5>2. Solicitud de Reembolso</h5>
                    <p>
                        Toda solicitud deberá presentarse por escrito dentro de los tres (3) días continuos siguientes a la fecha de entrega o a la fecha estimada de entrega, según corresponda.
                    </p>
                    <p>La solicitud deberá incluir, como mínimo:</p>
                    <ul>
                        <li>Número de guía o identificación del envío.</li>
                        <li>Nombre del remitente y del destinatario.</li>
                        <li>Descripción detallada de la situación.</li>
                        <li>Evidencia fotográfica cuando exista daño en la mercancía.</li>
                        <li>Factura o comprobante del valor de la mercancía, cuando sea requerido.</li>
                        <li>Cualquier otra documentación que la Empresa considere necesaria para evaluar la solicitud.</li>
                    </ul>
                    <p>La Empresa podrá solicitar información adicional antes de emitir una decisión.</p>

                    <h5>3. Casos en los que No Procede un Reembolso</h5>
                    <p>Salvo disposición legal en contrario, no procederán reembolsos o compensaciones cuando la situación sea consecuencia de:</p>
                    <ul>
                        <li>Retrasos ocasionados por procesos o inspecciones aduaneras.</li>
                        <li>Condiciones climáticas, desastres naturales o eventos de fuerza mayor.</li>
                        <li>Información incorrecta o incompleta proporcionada por el Cliente.</li>
                        <li>Embalaje inadecuado o insuficiente.</li>
                        <li>Mercancía prohibida o restringida.</li>
                        <li>Daños derivados de la naturaleza propia de la mercancía.</li>
                        <li>Actuaciones de autoridades gubernamentales.</li>
                        <li>Demoras atribuibles al destinatario o al remitente.</li>
                        <li>Servicios ya prestados de conformidad con lo contratado.</li>
                    </ul>

                    <h5>4. Evaluación de la Solicitud</h5>
                    <p>
                        Una vez recibida toda la documentación requerida, la Empresa realizará la investigación correspondiente y comunicará al Cliente el resultado de la evaluación.
                    </p>
                    <p>La Empresa podrá:</p>
                    <ul>
                        <li>Aprobar la solicitud.</li>
                        <li>Aprobar parcialmente la solicitud.</li>
                        <li>Rechazar la solicitud cuando no se acrediten los requisitos establecidos en esta política o en los Términos y Condiciones.</li>
                    </ul>

                    <h5>5. Forma y Plazo del Reembolso</h5>
                    <p>
                        Cuando una solicitud sea aprobada, el reembolso o compensación se procesará, siempre que sea posible, utilizando el mismo método de pago empleado en la transacción original.
                    </p>
                    <p>
                        El procesamiento normalmente se realizará dentro de los quince (15) días hábiles posteriores a la aprobación de la solicitud. Este plazo podrá variar dependiendo de la entidad financiera o del proveedor del servicio de pago.
                    </p>

                    <h5>6. Limitación de Responsabilidad</h5>
                    <p>
                        Todo reembolso o compensación estará sujeto a los límites de responsabilidad establecidos en los Términos y Condiciones de EnviarLatam LLC y, cuando corresponda, a la cobertura del seguro contratado por el Cliente.
                    </p>
                    <p>
                        En ningún caso la Empresa será responsable por daños indirectos, lucro cesante, pérdida de oportunidades comerciales o cualquier otro perjuicio consecuencial.
                    </p>

                    <h5>7. Modificaciones</h5>
                    <p>
                        EnviarLatam LLC podrá modificar esta Política de Reembolsos en cualquier momento. La versión vigente será la publicada en el sitio web de {brandName} y entrará en vigor desde su fecha de publicación.
                    </p>

                    <h5>8. Contacto</h5>
                    <p>
                        Si tiene preguntas sobre esta Política de Reembolsos o desea presentar una solicitud, puede comunicarse con nuestro equipo de atención al cliente a través de los canales oficiales publicados en el sitio web de {brandName}.
                    </p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={onHide}
                    className={modalStyles.closeBtn}
                >
                    Aceptar y Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RefundModal;
